import Store from '@/store'

export class LocalizationStoreUtils {
    static getLocalizations() {
        return Store.getters["localization-store/getLocalizations"];
    }

    static fethLocalizations() {
        return Store.dispatch("localization-store/fethLocalizations");
    }

    static addGroup(name, color, order){
        return Store.dispatch("localization-store/addGroup", {name, color, order});
    }

    static addKey(data){
        return Store.dispatch("localization-store/addKey", data);
    }

    static updateKeys(data){
        return Store.dispatch("localization-store/updateKeys", data);
    }

    static addKeys(data){
        return Store.dispatch("localization-store/addKeys", data);
    }

    static deleteGroup(data){
        return Store.dispatch("localization-store/deleteGroup", data);
    }

    static getLocaleKeys(){
        return Store.dispatch("localization-store/getLocaleKeys");
    }

    static removeLocaleKeys(keys){
        return Store.dispatch("localization-store/removeLocaleKeys", keys);
    }

    static uploadLocales(keys){
        return Store.dispatch("localization-store/uploadLocales", keys);
    }

    static editKeyValue(group_id, key_id, key_name, language, value){
        return Store.dispatch("localization-store/editKeyValue", {group_id, key_id, key_name, language, value});
    }

    static updateGroup(id, name, color, order){
        return Store.dispatch("localization-store/updateGroup", {id, name, color, order});
    }

    static deleteKey(key_id, key_name){
        return Store.dispatch("localization-store/deleteKey", {key_id, key_name});
    }
    /*
        static deleteConfig(uid) {
            return Store.dispatch("config-store/deleteConfig", uid);
        }

        static getReleaseConfigs() {
            return Store.getters["config-store/getReleaseConfigs"];
        }

        static pushReleaseConfig(value) {
            return Store.dispatch("config-store/pushReleaseConfig", value, true);
        }*/

}